import React, { useState, useContext } from "react";
import classes from "./AddNewTask.module.scss";
import Modal from "../Modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { ModalContext } from "../../store/modal-context";
import { BoardContext } from "../../store/board-context";

const AddNewTask = () => {
  const { modalPayload, closeModal } = useContext(ModalContext);
  const { boards, addNewTask } = useContext(BoardContext);
  const { boardId } = modalPayload;

  const board = boards.find((b) => b.id === boardId);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");
  const [subtasks, setSubtasks] = useState([
    { id: Date.now(), title: "", isCompleted: false },
  ]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!board) return null;

  const handleAddSubtask = (e) => {
    e.preventDefault();
    setSubtasks((prev) => [
      ...prev,
      { id: Date.now(), title: "", isCompleted: false },
    ]);
  };

  const handleSubtaskChange = (index, value) => {
    const updated = [...subtasks];
    updated[index].title = value;
    setSubtasks(updated);
  };

  const handleRemoveSubtask = (index) => {
    const updated = subtasks.filter((_, i) => i !== index);
    setSubtasks(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedTitle = title.trim();
    const trimmedDescription = description.trim();
    const validSubtasks = subtasks
      .filter((st) => st.title.trim())
      .map((st) => ({ ...st, title: st.title.trim(), id: Date.now() + Math.random() }));

    if (!trimmedTitle || !status) {
      alert("Please enter a task title and select a column.");
      return;
    }

    setIsSubmitting(true);
    await addNewTask(boardId, status, {
      title: trimmedTitle,
      description: trimmedDescription,
      subTasks: validSubtasks,
    });
    setIsSubmitting(false);

    setTitle("");
    setDescription("");
    setStatus("");
    setSubtasks([{ id: Date.now(), title: "", isCompleted: false }]);
    closeModal();
  };

  return (
    <Modal>
      <form className={`${classes.add_new_task}`} onSubmit={handleSubmit}>
        <h3>Add New Task</h3>

        <section className={`${classes.inputSection}`}>
          <label htmlFor="add-task-title">Title</label>
          <input
            id="add-task-title"
            type="text"
            placeholder="e.g. Take coffee break"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </section>

        <section className={`${classes.inputSection}`}>
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            className={classes.desc_textarea}
            placeholder="e.g. This break will recharge your batteries."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </section>

        <section className={`${classes.subtasks_section}`}>
          <p>Subtasks</p>
          <section className={classes.my_subtasks}>
            {subtasks.map((subtask, index) => (
              <div key={subtask.id}>
                <input
                  type="text"
                  placeholder={`e.g. Subtask ${index + 1}`}
                  value={subtask.title}
                  onChange={(e) => handleSubtaskChange(index, e.target.value)}
                />
                <button
                  type="button"
                  aria-label={`Remove subtask ${subtask.title || index + 1}`}
                  className={classes.xMarkButton}
                  onClick={() => handleRemoveSubtask(index)}
                >
                  <FontAwesomeIcon icon={faX} className={classes.xMark} aria-hidden="true" />
                </button>
              </div>
            ))}
          </section>
          <button
            className={`${classes.add_new_column}`}
            onClick={handleAddSubtask}
            disabled={isSubmitting}
          >
            + Add New Subtask
          </button>
        </section>

        <section className={classes.inputSection}>
          <label htmlFor="status">Status</label>
          <select
            name="status"
            id="status"
            className={classes.status}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">Select column</option>
            {board.columns.map((col) => (
              <option key={col.id} value={col.id}>
                {col.name}
              </option>
            ))}
          </select>
        </section>

        <button className={classes.save_changes} type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Creating…" : "Create Task"}
        </button>
      </form>
    </Modal>
  );
};

export default AddNewTask;
